"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.queryFromAgg = void 0;

var _react = require("react");

var _lodash = require("lodash");

var _api = _interopRequireDefault(require("../utils/api"));

var _mappingUtils = require("@arranger/mapping-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var aggFields = "\n  state {\n    field\n    show\n    active\n  }\n";

var queryFromAgg = function queryFromAgg(_ref) {
  var field = _ref.field,
      type = _ref.type;
  return type === 'Aggregations' ? "\n        ".concat(field, " {\n          buckets {\n            doc_count\n            key_as_string\n            key\n          }\n        }\n      ") : "\n      ".concat(field, " {\n        stats {\n          max\n          min\n          count\n          avg\n          sum\n        }\n      }\n      ");
};

exports.queryFromAgg = queryFromAgg;

var getMappingTypeOfField = function getMappingTypeOfField(_ref2) {
  var _get;

  var _ref2$mapping = _ref2.mapping,
      mapping = _ref2$mapping === void 0 ? {} : _ref2$mapping,
      _ref2$field = _ref2.field,
      field = _ref2$field === void 0 ? '' : _ref2$field;
  var mappingPath = field.split('__').join('.properties.');
  return _mappingUtils.esToAggTypeMap[(_get = (0, _lodash.get)(mapping, mappingPath)) === null || _get === void 0 ? void 0 : _get.type];
};

var _default = /*#__PURE__*/function (_Component) {
  _inherits(_default, _Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      aggs: [],
      temp: [],
      mapping: {}
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAggsState", (0, _lodash.debounce)( /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var graphqlField, _this$props$api, api, _yield$api, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                graphqlField = _ref3.graphqlField;
                _this$props$api = _this.props.api, api = _this$props$api === void 0 ? _api["default"] : _this$props$api;
                _context.prev = 2;
                _context.next = 5;
                return api({
                  endpoint: "/".concat(_this.props.projectId, "/graphql/aggsStateQuery"),
                  body: {
                    query: "query aggsStateQuery\n            {\n              ".concat(graphqlField, " {\n                mapping\n                aggsState {\n                  ").concat(aggFields, "\n                }\n              }\n            }\n          ")
                  }
                });

              case 5:
                _yield$api = _context.sent;
                data = _yield$api.data;

                _this.setState({
                  aggs: data[graphqlField].aggsState.state,
                  temp: data[graphqlField].aggsState.state,
                  mapping: data[graphqlField].mapping
                });

                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }));

      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }(), 300));

    _defineProperty(_assertThisInitialized(_this), "save", (0, _lodash.debounce)( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(state) {
        var _this$props$api2, api, _yield$api2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props$api2 = _this.props.api, api = _this$props$api2 === void 0 ? _api["default"] : _this$props$api2;
                _context2.next = 3;
                return api({
                  endpoint: "/".concat(_this.props.projectId, "/graphql"),
                  body: {
                    variables: {
                      state: state
                    },
                    query: "\n          mutation($state: JSON!) {\n            saveAggsState(\n              state: $state\n              graphqlField: \"".concat(_this.props.graphqlField, "\"\n            ) {\n              ").concat(aggFields, "\n            }\n          }\n        ")
                  }
                });

              case 3:
                _yield$api2 = _context2.sent;
                data = _yield$api2.data;

                _this.setState({
                  aggs: data.saveAggsState.state,
                  temp: data.saveAggsState.state
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }(), 300));

    _defineProperty(_assertThisInitialized(_this), "update", function (_ref6) {
      var field = _ref6.field,
          key = _ref6.key,
          value = _ref6.value;

      var agg = _this.state.temp.find(function (x) {
        return x.field === field;
      });

      var index = _this.state.temp.findIndex(function (x) {
        return x.field === field;
      });

      var temp = Object.assign([], _this.state.temp, _defineProperty({}, index, _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, key, value))));

      _this.setState({
        temp: temp
      }, function () {
        return _this.save(temp);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveOrder", function (orderedFields) {
      var aggs = _this.state.temp;

      if (orderedFields.every(function (field) {
        return aggs.find(function (agg) {
          return agg.field === field;
        });
      }) && aggs.every(function (agg) {
        return orderedFields.find(function (field) {
          return field === agg.field;
        });
      })) {
        _this.save((0, _lodash.sortBy)(aggs, function (agg) {
          return orderedFields.indexOf(agg.field);
        }));
      } else {
        console.warn('provided orderedFields are not clean: ', orderedFields);
      }
    });

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.fetchAggsState(this.props);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(next) {
      if (this.props.graphqlField !== next.graphqlField) {
        this.fetchAggsState(next);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var mapping = this.state.mapping;
      return this.props.render({
        update: this.update,
        aggs: this.state.temp.map(function (x) {
          var type = getMappingTypeOfField({
            field: x.field,
            mapping: mapping
          }) || x.type;
          return _objectSpread(_objectSpread({}, x), {}, {
            type: type,
            query: queryFromAgg(_objectSpread(_objectSpread({}, x), {}, {
              type: type
            })),
            isTerms: type === 'Aggregations'
          });
        }),
        saveOrder: this.saveOrder
      });
    }
  }]);

  return _default;
}(_react.Component);

exports["default"] = _default;